import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {ApiRestService} from "../api-rest.service";
import {ActivatedRoute} from "@angular/router";
import {Contenuto} from "../_Models/contenuto";
import {Blocco} from "../_Models/blocco";

@Component({
  selector: 'app-contenuti',
  templateUrl: './contenuti.component.html',
  styleUrls: ['./contenuti.component.css']
})
export class ContenutiComponent implements OnInit , OnChanges{
  public type: string;
  public List: Contenuto[];
  @Input() Blocco: Blocco;
  @Output() BloccoChange = new EventEmitter<Blocco>();
  constructor(
    private apiRest: ApiRestService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {

  }
  ngOnChanges():void {
    if(this.Blocco)
      this.refreshTable(this.Blocco?.id);
  }

  refreshTable(number?: number) {
    this.apiRest.ContenutoList({blocco_id: number}).subscribe(data=> this.List = data);
  }

  Edit(item: Contenuto) {
    item.blocco_id = this.Blocco?.id;
    item.modifica = !item.modifica;
    if(item.modifica && item.id)
      this.apiRest.GetContenuto({id: item.id}).subscribe(data=> item.testo = data);
    if(!item.modifica && !item.id)
      this.apiRest.ContenutoAdd(item).subscribe(() => this.refreshTable(this.Blocco?.id),error => item.modifica = true)
    if(!item.modifica && item.id)
      this.apiRest.ContenutoUpdate(item).subscribe(() => this.refreshTable(this.Blocco?.id),error => item.modifica = true)
  }
  delete(item: Contenuto){
    if(item.id)
      this.apiRest.ContenutoDelete(item).subscribe(()=>this.refreshTable(this.Blocco?.id))
    else {
      var idx = this.List?.findIndex(x => x == item);
      if (!isNaN(idx))
        this.List.splice(idx,1);
    }
  }

  Add() {
    this.List.push({modifica: true, blocco_id: this.Blocco?.id});
  }
}
